import { navigate } from '@reach/router'
import React, { useEffect, useState } from 'react'
import { TemplateProps } from '../../../journeys/journey/Interfaces'
import { Typography } from "@material-ui/core";
import { Button as AmsButton, CustomIcon, Cards, Spinner } from 'ams-ui-reactkit';
import { Dialog, TitleBlock } from '../../../atoms';
import Button from '@material-ui/core/Button';
import './Valuation.scss'
import { getValuationDetails } from '../../../graphql/getValuation.query';
import { StoreContext } from '../../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import { get } from 'lodash';
import { actionTypeConstants } from '../../../utils';
import DynamicHtml from '../../../molecules/DynamicHtml';
import { formateNumber, getCustomerId, getRandomNumber } from '../../../utils/Utils';

import TextField from '../../../atoms/TextField';
import FormControl from '@material-ui/core/FormControl';
import { create, all } from 'mathjs';

const config = {}
const math = create(all, config)

export interface SelectItemprops {
    popUpTitle: any
    popUpContent: any
}

const Valuation: React.FC<TemplateProps> = (props: any) => {
    const customerInfo: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);
    const customerId = getCustomerId() || ""
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const { templateProps } = props;
    const [open, SetPopup] = useState(false)
    const [isUpdate, SetisUpdate] = useState(false)
    const [popupData, setPopupData] = useState<SelectItemprops>();
    const [loader, setLoader] = useState(false);
    const [shipperDeclaredField, setShipperDeclaredField] = useState(true);

    const [deductibleOptionsLoading, setDeductibleOptionsLoading] = useState(false);
    const valuationData = customerInfo?.valuationDetails || {}
    const [disableValuationBtn, setDisableValuationBtn] = useState(false);
    const defaultShipmentValue:any = useContextSelector(StoreContext, store => (store?.appState?.valuationInfo as any)?.defaultShipmentValue) || null;
    const shipmentValue: any = useContextSelector(StoreContext, store => (store?.appState?.valuationInfo as any)?.shipmentValue) || null;
    const shipperDeclaredValue: any = useContextSelector(StoreContext, store => (store?.appState?.valuationInfo as any)?.shipperDeclaredValue) || null;
    const shipperDeclaredLabel: any = useContextSelector(StoreContext, store => (store?.appState?.valuationInfo as any)?.shipperDeclaredLabel) || null;

    useEffect(() => {
        if (customerId && Object.keys(valuationData).length === 0) {
            getValutionDetails()
        }
    }, [])

    useEffect(() => {
         shipperDeclaredValue && calculatePremium(shipperDeclaredValue);
    }, [shipperDeclaredValue]);

    const getValutionDetails = async () => {
        setLoader(true)
        let resp = await getValuationDetails(customerId);
        if (resp) {
            let parseData = JSON.parse(resp);
            console.log("resppp",parseData);
            const defaultShipValue = get(parseData, "items.0.declaredDetails.value");

            //TODO UPDATE_VALUATION_DETAILS move to pageTemplate reducer
            dispatch({
                type: actionTypeConstants.UPDATE_VALUATION_DETAILS,
                payload: parseData
            });

            dispatch({
                type: actionTypeConstants.DEFAULT_SHIPMENT_VALUE,
                payload: {
                    defaultShipmentValue: defaultShipValue
                }
            });

            dispatch({
                type: actionTypeConstants.UPDATE_DEDUCTIBLE_OPTIONS,
                payload: {
                    deductibleOptions: get(parseData, "items.0.deductibleOptions.items", [])
                }
            });

            dispatch({
                type: actionTypeConstants.SHIPPER_DECLARED_VALUE,
                payload: {
                    shipperDeclaredLabel: get(parseData, "items.0.declaredDetails.shipperLabel"),
                    shipperDeclaredValue: get(parseData, "items.0.declaredDetails.shipperValue")
                }
            });
            



        }
        setLoader(false)
    }
    const handleClose = () => {
        SetPopup(false)
    }

    const openPopUP = (item: any) => {
        SetPopup(true)
        SetisUpdate(false)
        setPopupData({
            "popUpTitle": item.title,
            "popUpContent": item.content
        })


    }
    const PopupFooter = () => {
        return <>
            <Button onClick={handleClose} color="primary" variant="outlined" className='b-transparent'>
                {"CLOSE"}
            </Button>
            {isUpdate &&
                <Button onClick={handleClose} color="primary" variant="contained" >
                    {"UPDATE"}
                </Button>

            }
        </>
    }

    const PopupBody = () => {
        return <div className="full-block">
            <Typography variant="body2" variantMapping={{ body2: "div" }} align='left' className="fw-400 color-grey">
                <DynamicHtml content={popupData?.popUpContent} />
            </Typography>
        </div>
    }
   

    const getOptionDetails = (selectedOption: any) => {

        let shipmentVal = shipmentValue || (shipperDeclaredValue!="0"?shipperDeclaredValue:null)|| defaultShipmentValue ;
        let premiumformulas = templateProps?.premiumformula?.filter((data: any) => data?.deductibleId === `${selectedOption?.deductibleId}` && selectedOption?.optionId === 1);
        let premium: any = math.evaluate(premiumformulas[0]?.formula, { shipmentValue: shipmentVal });
        let premimumType = selectedOption?.optionId === 1 && selectedOption?.deductibleId === 0 ? "$0.00" : "$250.00";

        return [
            {
                "label": "Total Value of Shipment:",
                "value": `$ ${formateNumber(fixDecimalstoTwo(shipmentVal))}`,
            },
            {
                "label": "Deductible:",
                "value": premimumType
            },
            {
                "label": "FVP Premium:",
                "subText": "<div class='color-red'>Added to the cost of your move</div>",
                "value": `$${formateNumber(fixDecimalstoTwo(premium))}`
            }
        ];
    }

    const handleButton = async (selectedOption?: any) => {

        dispatch({
            type: actionTypeConstants.SELECTED_VALUATION_OPTIONS,
            payload: {
                "optionId": selectedOption?.optionId,
                "deductibleId": selectedOption?.deductibleId
            }
        });

        let selectedOptionData: any;
        if (selectedOption?.optionId === 1) {
            selectedOptionData = getOptionDetails(selectedOption)
        }
        dispatch({
            type: actionTypeConstants.UPDATE_SELECTED_OPTIONS_DATA,
            payload: {
                "selectedOption": selectedOptionData,
            }
        });
        navigate(templateProps?.nextScreen)
    }


    const ShowButton = (option: any) => {
        return (
            <AmsButton
                text={option?.buttonName}
                onClick={() => { handleButton(option) }}//handleButton(option?.details)
                color={"primary"}
                variant={"contained"}
                size={"medium"}
                disabled={disableValuationBtn}
            />
        )
    }

    const fixDecimalstoTwo = (val: any) => {
        var n = Number.parseFloat(val);
        if (!val || isNaN(n) || n < 0) return 0;
        return n.toFixed(2);
    }


    const calculatePremium = async (shipVal: any) => {
        setDeductibleOptionsLoading(true);
        let premiumData: any = []
        templateProps?.premiumformula?.forEach((item: any, index: any) => {
            let premiumAmount = fixDecimalstoTwo(math.evaluate(item.formula, { shipmentValue: shipVal }));
            let premiumType = item.deductibleId === "0" ? 0 : 250;
            let totalCost = fixDecimalstoTwo(valuationData?.totalCost || 0);
            let moveAmt = Number(totalCost) + Number(premiumAmount);
            let dedobj = {
                deductibleId: index,
                footerText: "Move Cost: $ " + formateNumber(moveAmt),
                premium: `$ ${formateNumber(premiumAmount)}`,
                title: `Full Replacement Value Protection / $ ${formateNumber(premiumType)} Deductible Cost:`
            }
            premiumData.push(dedobj)

        })
        setDeductibleOptionsLoading(false);
        if (premiumData) {
            dispatch({
                type: actionTypeConstants.UPDATE_DEDUCTIBLE_OPTIONS,
                payload: {
                    deductibleOptions: premiumData,
                }
            });
        }

    }

    const isValidShipmentValue = (value?: any) => {

        const shipValue = value || shipmentValue;
        try {
            if (parseInt(shipValue) < parseInt(defaultShipmentValue) || parseInt(shipValue) > valuationData?.maxValue) {
                return false;
            }
        } catch (e) {
            console.log('Error occured while converting shipment value to int');
        }


        return true;
    }

    const renderShipmentValueComp = (fieldData: any) => {


        const onBlurHandler = (value: any) => {
            if (value === "" || value === null || value === undefined) {
                dispatch({
                    type: actionTypeConstants.UPDATE_SHIPMENT_VALUE,
                    payload: {
                        shipmentValue: defaultShipmentValue
                    }
                });
                calculatePremium(defaultShipmentValue);
                setDisableValuationBtn(false);

            }
            else {

                dispatch({
                    type: actionTypeConstants.UPDATE_SHIPMENT_VALUE,
                    payload: {
                        shipmentValue: value
                    }
                });

                if (isValidShipmentValue(value)) {
                    calculatePremium(value);
                    setDisableValuationBtn(false);
                } else {
                    setDisableValuationBtn(true);
                }

            }


        }

        const RenderShipmentFieldLabel = () => {

            if ( (shipmentValue === null && !shipperDeclaredValue) || shipmentValue === defaultShipmentValue) {
                return <Typography variant="caption"
                    variantMapping={{ caption: "div" }}
                    className="color-grey2" noWrap={false} align='left'>
                    {"Default Value (Total weight estimated weight of your shipment x$6 per pound)"}
                </Typography>
            } else if ( (shipmentValue === null && shipperDeclaredValue) || shipmentValue === shipperDeclaredValue) {
                return <Typography variant="caption"
                    variantMapping={{ caption: "div" }}
                    className="color-grey2" noWrap={false} align='left'>
                    {shipperDeclaredLabel}
                </Typography>
            }

            return null;

        }

        const handleRefreshShipment = () => {
            // console.log("handleRefreshShipment");

            setShipperDeclaredField( shipperDeclaredField => {

                const shipmentFieldValue = !shipperDeclaredField ? shipperDeclaredValue  : defaultShipmentValue;

                dispatch({
                    type: actionTypeConstants.UPDATE_SHIPMENT_VALUE,
                    payload: {
                        shipmentValue: shipmentFieldValue
                    }
                });
                
                if (isValidShipmentValue(shipmentFieldValue)) {
                    calculatePremium(shipmentFieldValue);
                    setDisableValuationBtn(false);
                } else {
                    setDisableValuationBtn(true);
                }
                
                return !shipperDeclaredField;
            } );
            
           

        };

        // console.log("shipperDeclaredValue, shipmentValue ,  defaultShipmentValue ",shipperDeclaredValue, shipmentValue, defaultShipmentValue);
        return (
            <div className="shipmentData mb-8">
                <FormControl fullWidth >
                    <TextField label={fieldData?.label}
                        defaultValue={shipmentValue || (shipperDeclaredValue!="0"?shipperDeclaredValue:null) || defaultShipmentValue }
                        startAdorment="$"
                        onBlur={onBlurHandler}
                        //error={!isValidShipmentValue()}
                        helperText={!isValidShipmentValue() ? `Shipment value should be with in ${formateNumber(defaultShipmentValue)} and 100,000` : undefined}
                        endAdornment={shipperDeclaredValue && "AutorenewOutlined"}
                        endAdornmentClick={shipperDeclaredValue && handleRefreshShipment}
                    />
                </FormControl>
                <RenderShipmentFieldLabel/>
                {/* <FormList
                    list={textField}
                    formData={{
                        "coverageAmount": shipmentValue
                    }}
                    onChange={debounceChangeHandler}
                /> */}
                {/* {(shipmentValue === null || shipmentValue === defaultShipmentValue) && <Typography variant="caption"
                    variantMapping={{ caption: "div" }}
                    className="color-grey2" noWrap={false} align='left'>
                    {"Default Value (Total weight estimated weight of your shipment x$6 per pound)"}
                </Typography>} */}
            </div>
        )
    }

    const DeductibleOptionCard = (propsObj: any) => {

        const { title, premium, footerText } = propsObj;
        return (
            <>
                {title &&
                    <Typography variant='body1' color='textPrimary'
                        variantMapping={{ caption: "div" }} className="fw-500 color-red mb-8"
                        noWrap={false} align='center'>
                        {title}
                    </Typography>
                }
                {premium &&
                    <Typography variant='body2' color='textPrimary'
                        variantMapping={{ caption: "div" }} className="fw-400 color-grey2 mb-8"
                        noWrap={false} align='center'>
                        {premium}
                    </Typography>
                }
                {footerText &&
                    <Typography variant='body2' color='textPrimary'
                        variantMapping={{ caption: "div" }} className="fw-900 color-grey mb-8"
                        noWrap={false} align='center'>
                        {footerText}
                    </Typography>
                }

            </>
        );
    }

    const RenderOptionWithDeductibleOptions = (propsObj: any) => {
        const optionId = propsObj?.optionId || "1";
        const deductibleOptions: any = useContextSelector(StoreContext, store => (store?.appState?.valuationInfo as any)?.deductibleOptions);

        if (deductibleOptionsLoading) {
            return ShowLoader();
        }
        if (deductibleOptions?.length > 0) {
            return (
                <div className="full-block mt-8">
                    {deductibleOptions?.map((options: any, i: any) => {
                        return (

                            <div className="optionCard p-8 border-l br-8 mb-8" key={i}>
                                <DeductibleOptionCard {...options} />
                                <div>
                                    <ShowButton buttonName={"SELECT FULL VALUATION"}
                                        optionId={optionId} deductibleId={options?.deductibleId}
                                        buttonId={getRandomNumber()} />
                                </div>
                            </div>

                        )
                    })
                    }
                </div>
            );
        }

        return null;

    }

    const renderDeductibleOptions = (item = {} as any) => {

        if (item?.deductibleOptions?.items?.length > 1) {
            return <RenderOptionWithDeductibleOptions optionId={item.id} />;
        }
        else {
            return (
                <div>
                    {item?.deductibleOptions?.items[0] &&
                        <div className="mt-8">
                            <Typography variant='body2' color='textPrimary' variantMapping={{ caption: "div" }} className="fw-900 color-grey mb-8" noWrap={false} align='center'>
                                {item?.deductibleOptions?.items[0]?.footerText}
                            </Typography>

                            <ShowButton buttonName={"SELECT STANDARD VALUATION"} {...{ ...item?.deductibleOptions?.items[0], optionId: item.id }} />
                        </div>
                    }
                </div>
            );
        }

    }

    const OptionCard = (item: any) => {
        // console.log("item?.PremiumText",item?.PremiumText)
        return (
            <div className="singleCard border-1-light br-8 p-8 w-100-p8 f-left mb-16">
                <div className="singleCardItemTitle mb-8">
                    <Typography variant='h5' color='textPrimary' className="mb-0 fw-400 color-grey" noWrap={false} align='left'>
                        {item?.title}
                    </Typography>
                    <span onClick={item?.helper ? () => { openPopUP(item?.helper) } : () => { return null }}><CustomIcon iconName={"InfoOutlined"} /></span>
                </div>

                <Typography variant="h6" className="color-red mb-8" noWrap={false} align='left'>
                    {item?.subTitle}
                </Typography>
                <Typography variant="caption" className="color-grey" noWrap={false} align='left'>
                    <DynamicHtml content={item?.content} />
                </Typography>

                {item?.declaredDetails?.label &&
                    renderShipmentValueComp(item?.declaredDetails)
                }

                {/* <div className={`${item?.declaredDetails?.label && "border-t-l"} pt-16`}>
                    <Typography variant='subtitle2' color='textPrimary' className="color-grey mb-8" noWrap={false} align='left'>
                        {item?.deductibleOptions.title}
                    </Typography>
                    <Typography variant='caption' color='textPrimary' className="color-grey mb-8" noWrap={false} align='left'>
                        <DynamicHtml content={item?.deductibleOptions.subTitle} />
                    </Typography>
                </div> */}

                {item?.PremiumText &&
                    <div>{item?.PremiumText}</div>
                }

                {renderDeductibleOptions(item)}
            </div>
        )
    }

    const ShowLoader = () => {

        return <div className='full-block'>
            <div className='flex-center-50h'>
                <Spinner />
            </div>
        </div>
    }

    const ValuationOptions = () => {

        return <Cards variant="default">
            <div className="cardsList">
                {
                    valuationData?.items?.map((item: any, i: any) => <OptionCard key={i} {...item} />)
                }
            </div>
            <Dialog title={popupData?.popUpTitle} open={open} handleClose={handleClose} footer={PopupFooter()}>
                {PopupBody()}
            </Dialog>
        </Cards>
    }

    return (
        <div className="baseContainerBlock valuationPage">

            <TitleBlock title={templateProps?.title} />
            <Typography variant="caption" color='textPrimary' noWrap={false} align='center' className='color-red full-block pb-16 fw-500'>
                {templateProps?.subtitle}
            </Typography>

            {loader ? <ShowLoader /> : <ValuationOptions />}

        </div>
    )
}

export default Valuation
